import { AfterViewInit, ComponentRef, Directive, ElementRef, OnDestroy, Renderer2, ViewContainerRef } from '@angular/core';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import * as Sentry from '@sentry/angular';

const IMG_ERROR_PLACEHOLDER = 'image_error_placeholder.png';

@Directive({
  selector: '[appImageZoom]',
  standalone: true,
})
export class ImageZoomDirective implements AfterViewInit, OnDestroy {
  private modalRef: ComponentRef<ImageModalComponent> | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainer: ViewContainerRef,
  ) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.setupImageClickHandlers();
    }, 0);
  }

  private setupImageClickHandlers() {
    const images = this.el.nativeElement.querySelectorAll('img');

    images.forEach((img: HTMLImageElement) => {
      const origImgSrc = img.src;
      this.renderer.listen(img, 'click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        let imgSrc = img.src;
        if (imgSrc.includes(IMG_ERROR_PLACEHOLDER)) {
          const message = `[ImageZoomDirective] Original image could not be loaded. Url: ${origImgSrc}`;
          Sentry.captureMessage(message, {
            tags: {
              location: 'ImageZoomDirective',
              feature: 'ImageZoom',
              message: message,
            },
          });
          imgSrc = '';
        }
        this.openImageModal(imgSrc, img.alt);
      });
    });
  }

  private openImageModal(src: string, alt: string) {
    this.modalRef = this.viewContainer.createComponent(ImageModalComponent);
    this.modalRef.instance.imageSrc = src;
    this.modalRef.instance.imageAlt = alt;

    this.modalRef.instance.closeModal.subscribe(() => {
      this.closeModal();
    });

    this.renderer.appendChild(document.body, this.modalRef.location.nativeElement);
  }

  private closeModal() {
    if (this.modalRef) {
      this.renderer.removeChild(document.body, this.modalRef.location.nativeElement);
      this.modalRef.destroy();
      this.modalRef = null;
    }
  }

  ngOnDestroy() {
    this.closeModal();
  }
}
